import styled from 'styled-components';

const Header = styled.header<any>`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 32px;
  & > * {
    margin: 4px;
  }
`;

export default Header;
